import Backbone from "backbone";
import * as _ from "underscore";

import * as utils from "shared/utils";

const ShelfModel = Backbone.Model.extend({
  urlRoot: "/api/shelf",
  idAttribute: "_id",

  // WARNING: only designed to work on itemIDs - not on wholePage / wholeCollection selections
  getBookIndex: function () {
    if (!this._bookIndex) {
      this._bookIndex = {};
      _.each(this.get("books"), (book) => {
        this._bookIndex[book.bookID] = book;
      });
    }
    return this._bookIndex;
  },

  set: function (...args) {
    // invalidate index
    delete this._bookIndex;

    if (args[0] === "books" || args[0].books) {
      const previousBooks = _.pluck(this.get("books"), "bookID");
      const result = Backbone.Model.prototype.set.apply(this, args as any);

      const newBooks = _.pluck(this.get("books"), "bookID");
      const booksAdded = _.difference(newBooks, previousBooks);
      const booksRemoved = _.difference(previousBooks, newBooks);

      if (booksAdded.length > 0) {
        this.trigger("booksAdded", this, booksAdded);
      }
      if (booksRemoved.length > 0) {
        this.trigger("booksRemoved", this, booksRemoved);
      }

      return result;
    }

    return Backbone.Model.prototype.set.apply(this, args as any);
  },

  getPrivacyValue: function () {
    return !this.get("public")
      ? "private"
      : this.get("hide")
        ? "linkOnly"
        : "public";
  },

  setPrivacyValue: function (value) {
    let update = {};

    switch (value) {
      case "private":
        update = { public: false, hide: false };
        break;

      case "linkOnly":
        update = { public: true, hide: true };
        break;

      case "public":
        update = { public: true, hide: false };
        break;

      default:
        throw Error("Invalid privacy value: " + value);
    }

    this.save(update, { patch: true });
  },

  viewJSON: function () {
    const json = this.toJSON();
    json.descriptionHtml = utils.simpleMarkupToHtml(json.description);

    const privacyValue = this.getPrivacyValue();
    json.privacyValues = {
      private: privacyValue === "private",
      linkOnly: privacyValue === "linkOnly",
      public: privacyValue === "public",
    };
    return json;
  },

  addBookID: function (bookID) {
    this.addBookIDs([bookID]);
  },
  addBookIDs: function (bookIDs) {
    this.set(
      "books",
      _.chain(this.get("books"))
        .pluck("bookID")
        .union(bookIDs)
        .map((id) => ({
          bookID: id,
        }))
        .value()
    );
  },
});

export default ShelfModel;
